import { Identify } from "amplitude-js"
import { platform } from "~/utils/platform"

export function platformIdentify(identify: Identify) {
	identify.set("Platform", platform.isMobile ? "Mobile" : "Desktop")
}
